<style>
#files {
    position: relative;
    z-index: 0;
}

#files:focus {
    outline: 0;
    border: 0;
    box-shadow: none;
}
</style>
<template>
    <Head title="QM - Movimentos"/>

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-4xl text-white leading-tight lobster">
                Importar Movimentos
            </h2>
        </template>

        <div class="py-2 flex flex-wrap justify-center">
            <div class="w-11/12 sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm rounded-lg">
                    <div class="p-6 bg-slate-100 border-b border-gray-200">
                        <div id="app">
                            <div id="loader"
                                 class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
                                 :class="{hidden: loaderHidden}">
                                <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
                                    <img class="inline-block" src="/storage/img/loader.gif"/>
                                </div>
                            </div>
                            <form @submit.prevent="form.post('/dashboard', options)">
                                <div class="text-center my-5">
                                    <div class="inline bg-slate-100 relative py-1" style="z-index: 2;">
                                        <label for="files"
                                               class="inline bg-white cursor-pointer hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"><i
                                            class="fas fa-upload"></i> Escolher XLS/XLSX</label>
                                    </div>
                                    <input :style="{marginLeft: fileMarginLeft}"
                                           multiple required
                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                           type="file" id="files" class="hidden lg:inline" @input="form.files = $event.target.files"/>
                                </div>
                                <div class="text-center mt-5">
                                    <button type="submit"
                                            class="bg-white hover:bg-gray-100 mr-2 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow">
                                        Importar movimentos
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import {Head, useForm} from '@inertiajs/inertia-vue3';
import {Inertia} from '@inertiajs/inertia';
import Swal from "sweetalert2";
import {ref} from "vue";

export default {
    components: {
        BreezeAuthenticatedLayout,
        Head,
    },
    props: {
        site_url: String
    },
    setup() {
        const loaderHidden = ref(true);
        const form = useForm({
            files: null
        });

        function load() {
            document.getElementById('loader').classList.toggle('hidden');
        }

        const options = {
            onBefore: function () {
                loaderHidden.value = false;
            },
            onSuccess: function (result) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    html: 'Extratos importados com sucesso!'
                }).then(function () {
                    loaderHidden.value = true;
                });
                form.reset();
            },
            onError: function () {
                Swal.fire('Erro, por favor tente mais tarde!', '', 'error');
            }
        }
        return {form, options, loaderHidden}
    },
    computed: {
        fileMarginLeft() {
            if (/Edg/.test(navigator.userAgent)) {
                return '-123px';
            } else if (/Chrome/.test(navigator.userAgent)) {
                return '-149px';
            } else if (/Firefox/.test(navigator.userAgent)) {
                return '-101px';
            }
        }
    }
}
</script>
